import React from "react";
import "./Driven_By_Purpose.css";
import Common_Title_1 from "../../common_components/common_title_1/Common_Title_1";

const Driven_By_Purpose = () => {
  return (
    <section className="Driven_By_Purpose section_margin">
      <div className="container">
        <div className="content_div">
          <Common_Title_1
            titleText={"Driven by Purpose, Guided by Vision"}
            subText={
              "We aim to empower every learner with simple, reliable, and impactful solutions."
            }
          />

          <div className="data_div">
            <div className="row justify-content-center align-items-center">
              <div className="col-lg-6 order-lg-1 order-2">
                <div className="gray_box box1">
                  <div className="img_holder">
                    <img
                      src="/assets/images/home/vission_mission/img1.png"
                      className="inner_img"
                    />
                  </div>
                  <p className="inner_text">
                    To become a trusted and innovative platform that empowers
                    individuals and professionals to learn, grow, and achieve
                    their full potential.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 order-lg-2 order-1">
                <p className="section_title_text">VISION</p>
              </div>

              <div className="col-lg-6 order-3">
                <p className="section_title_text mission_text">MISSION</p>
              </div>

              <div className="col-lg-6 order-4">
                <div className="gray_box box2">
                  <p className="inner_text">
                    To deliver accessible, reliable, and impactful solutions
                    through tailored plans, user-friendly services, and
                    continuous support helping our users succeed at every step
                    of their journey.
                  </p>
                  <div className="img_holder">
                    <img
                      src="/assets/images/home/vission_mission/img2.png"
                      className="inner_img"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Driven_By_Purpose;
